export const DownArrowIcon = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00008 9.76921L5.06421 6.83334H10.9359L8.00008 9.76921Z"
        fillOpacity="0.2"
      />
    </svg>
  );
};
